import { render, staticRenderFns } from "./FlashSales.vue?vue&type=template&id=2b0d5ca7&scoped=true&"
import script from "./FlashSales.vue?vue&type=script&lang=js&"
export * from "./FlashSales.vue?vue&type=script&lang=js&"
import style0 from "./FlashSales.vue?vue&type=style&index=0&id=2b0d5ca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d5ca7",
  null
  
)

export default component.exports